var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.11 52.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.46l5.92 6.79c14.71-16.88 38.56-16.88 53.27 0l5.9-6.79C47.15-5.15 18-5.15 0 15.46zm23.68 27.13l8.88 10.19 8.87-10.19a11.43 11.43 0 0 0-17.75 0zM11.84 29.04l5.92 6.79c8.17-9.37 21.42-9.37 29.59 0l5.92-6.79c-11.42-13.11-29.98-13.11-41.43 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/WIFI.134f3b734f13f2ce94d95efe85bab91b.svg";
export { ForwardRef as ReactComponent };